import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sfooter desk" }, [
  /*#__PURE__*/_createTextVNode(" Solsunsets© 2022 | Powered by "),
  /*#__PURE__*/_createElementVNode("a", {
    alt: "home",
    href: "https://solsunsets.com"
  }, [
    /*#__PURE__*/_createElementVNode("object", {
      href: "https://solsunsets.com",
      id: "svg1",
      data: "https://solsunsets.com/img/logo/logo-sln.svg",
      class: "logo-sln"
    })
  ])
], -1)
const _hoisted_2 = { class: "blog" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\"><a href=\"https://solsunsets.com\"><object href=\"https://solsunsets.com\" id=\"svg1\" data=\"https://solsunsets.com/img/logo/logo-ss-m.svg\" class=\"logo-ss\"></object></a></div><div class=\"blog-header-container\"><div class=\"blog-intro desk\"><div class=\"logo-links\"><a alt=\"home\" href=\"https://solsunsets.com\"><object href=\"https://solsunsets.com\" id=\"svg1\" data=\"https://solsunsets.com/img/logo/home.svg\" class=\"logo-twitter mob\"></object></a><a href=\"https://twitter.com/solsunsets\"><object href=\"https://twitter.com/solsunsets\" id=\"svg2\" data=\"https://solsunsets.com/img/logo/logo-ttr.svg\" class=\"logo-twitter\"></object></a><a href=\"https://discord.gg/RNSRHaxzbR\"><object href=\"https://discord.gg/RNSRHaxzbR\" id=\"svg3\" data=\"https://solsunsets.com/img/logo/logo-dsc.svg\" class=\"logo-discord\"></object></a><a href=\"https://docs.solsunsets.com\"><object href=\"https://docs.solsunsets.com\" id=\"svg4\" data=\"https://solsunsets.com/img/logo/logo-gtb.svg\" class=\"logo-discord\"></object></a><a href=\"https://www.magiceden.io/marketplace/solsunsets\"><object href=\"https://www.magiceden.io/marketplace/solsunsets\" id=\"svg5\" data=\"https://solsunsets.com/img/logo/logo-me.svg\" class=\"logo-discord\"></object></a></div><span style=\"overflow:scroll;max-height:176px;\"> Solsunsets is an Art Collection of generative landscapes inspired by the aesthetics of pop culture, nostalgic childhood memories, obsolete technologies and jazz fusion from the 80s. From the 1,33B possible combinations between the 112 handcrafted attributes (skies, suns, horizons and objects), only 4,444 striking and unique pieces were generated. A project by <a href=\"https://twitter.com/rgb0x00\">@rgb0x00</a></span></div></div>", 2)
const _hoisted_5 = { class: "blog-part" }
const _hoisted_6 = { class: "blog-right" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"intro\"><div class=\"mob\"><a class=\"nav-link\" href=\"https://solsunsets.com\"><b><object href=\"https://solsunsets.com\" id=\"svg1\" data=\"https://solsunsets.com/img/logo/arrow.svg\" class=\"logo-rotate\"></object>HOME </b></a></div><h1>Banners &amp; alternates</h1><div class=\"preview\"><div> Connect your wallet to have access to all Solsunsets your banners. You are able to switch between the Sunny Pack (SP) or the Original (OG) versions of your Solsunset. Also, in the search field on top, you can find any Solsunsets of the main collection. </div></div></div>", 1)
const _hoisted_8 = { class: "connect" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "cbz" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    class: "cbz",
    id: "cbz",
    checked: ""
  }),
  /*#__PURE__*/_createElementVNode("label", { for: "cbz" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div id=\"menu\" class=\"blog-part desk\"><div class=\"blog-right-title-container\"></div><div class=\"bbutton\"><a class=\"cyan\" href=\"https://gallery.solsunsets.com/\">Solsunsets Banners</a></div><div class=\"bbutton desk\"><a class=\"cyan\" href=\"https://claim.solsunsets.com/\">Pixels Claim</a></div><div class=\"bbutton desk\"><a class=\"cyan\" href=\"https://up.solsunsets.com/\">Pixel Art Upscale Tool</a></div><div class=\"bbutton\">Markets: <a class=\"cyan\" href=\"https://www.magiceden.io/marketplace/solsunsets\">MagicEden<object id=\"svg1\" data=\"https://solsunsets.com/img/logo/open.svg\" style=\"height:1em;margin-bottom:-0.2em;\"></object></a> | <a href=\"https://alpha.art/collection/solsunsets/\">Alpha.Art<object id=\"svg1\" data=\"https://solsunsets.com/img/logo/open.svg\" style=\"height:1em;margin-bottom:-0.2em;\"></object></a></div><div class=\"bbutton desk\">Sci-fi Series:<a class=\"cyan\" href=\"https://exchange.art/collections/Solsunsets%20Sci-Fi%20Series\">Exchange.Art<object id=\"svg1\" data=\"https://solsunsets.com/img/logo/open.svg\" style=\"height:1em;margin-bottom:-0.2em;\"></object></a></div><div class=\"bbutton desk\">Rarity: <a class=\"cyan\" href=\"https://moonrank.app/collection/solsunsets\">Moonrank<object id=\"svg1\" data=\"https://solsunsets.com/img/logo/open.svg\" style=\"height:1em;margin-bottom:-0.2em;\"></object></a> | <a class=\"cyan\" href=\"https://howrare.is/solsunsets\">Howrare<object id=\"svg1\" data=\"https://solsunsets.com/img/logo/open.svg\" style=\"height:1em;margin-bottom:-0.2em;\"></object></a></div></div>", 1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div style=\"height:280px;\" class=\"desk\"></div><div class=\"nftpre\" id=\"prev\"><h2 class=\"title\" id=\"solscan\"></h2><div class=\"og ssuns\"><p id=\"bog\"></p><p id=\"pog\"></p></div><div class=\"sp ssuns\"><p id=\"bsp\"></p><p id=\"psp\"></p></div></div>", 2)
const _hoisted_13 = {
  key: 2,
  class: "nftdisplay"
}
const _hoisted_14 = { class: "infinite-loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_NFTViewForm = _resolveComponent("NFTViewForm")!
  const _component_LoadingBar = _resolveComponent("LoadingBar")!
  const _component_NotifyError = _resolveComponent("NotifyError")!
  const _component_NFTViewCard = _resolveComponent("NFTViewCard")!
  const _component_infinite_loading = _resolveComponent("infinite-loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ConfigPane),
            _createVNode(_component_NFTViewForm, {
              "is-loading": _ctx.isLoading,
              onSubmitForm: _ctx.handleSubmitForm
            }, null, 8, ["is-loading", "onSubmitForm"]),
            _hoisted_9
          ])
        ])
      ]),
      _hoisted_10
    ]),
    _hoisted_11,
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingBar, {
          key: 0,
          progress: _ctx.progress,
          text: _ctx.text,
          class: "my-5"
        }, null, 8, ["progress", "text"]))
      : (_ctx.isError)
        ? (_openBlock(), _createBlock(_component_NotifyError, {
            key: 1,
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.text), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NFTs, (n) => {
              return (_openBlock(), _createBlock(_component_NFTViewCard, {
                key: n.mint,
                n: n
              }, null, 8, ["n"]))
            }), 128))
          ])),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_infinite_loading, {
        style: {"color":"black"},
        onInfinite: _ctx.infiniteHandler,
        identifier: 
        +new Date() //needs to be something thta dynamically updates, or won't work
      ,
        spinner: "spiral"
      }, null, 8, ["onInfinite", "identifier"])
    ])
  ]))
}